<template>
    <div class="form_field flex_field border-bottom">
      <div class="label_container_average">
        <div class="average">
          <label for="km_mensili">Media km mensili</label>
          <div class="iconTooltip__container" @click="toggleTooltip('km')">
            <span class="qrt-icon-Icona_Information">
              <img
                src="../../../images/project-img/Icon-information-circle.png"
                alt="info icon"
                width="20px"
              />
            </span>
            <div class="tooltip" :class="{ 'tooltip-visible': tooltipVisible === 'km' }">
              <p>
                Inserendo i chilometri medi/mese percorsi possiamo mostrare nell'attestato se utilizzi
                la moto di più o di meno rispetto alla media dei proprietari di veicoli simili.
                <br /><br />
                Questo permette di massimizzare i tempi di compra/vendita della moto.
                <br /><br />
                Se non inserisci i km medi/mese inseriremo un valore stimato dal chilometraggio totale.
              </p>
            </div>
          </div>
        </div>
        <div class="input_container">
          <input
            type="text"
            name="km_mensili_formatted"
            v-model="kmMensiliInput"
            @input="onKmMensiliInput"
            :placeholder="'Km'"
            inputmode="numeric"
            class="no-spinners"
            autocomplete="off"
          />
          <input type="hidden" name="km_mensili" :value="kmMensiliNumeric" />
        </div>
      </div>

      <div class="label_container_average">
        <div class="average">
          <label for="cap">CAP</label>
          <div class="iconTooltip__container" @click="toggleTooltip('cap')">
            <span class="qrt-icon-Icona_Information">
              <img
                src="../../../images/project-img/Icon-information-circle.png"
                alt="info icon"
                width="20px"
              />
            </span>
            <div class="tooltip" :class="{ 'tooltip-visible': tooltipVisible === 'cap' }">
              <p>
                Con il CAP possiamo indicare nell'attestato a che distanza si trovano i veicoli
                simili/concorrenti al veicolo quotato, ottenendo le corrette informazioni sui prezzi e le
                condizioni dei veicoli in zona.
                <br /><br />
                Omettendo il CAP questo elemento non verrà visualizzato.
              </p>
            </div>
          </div>
        </div>
        <div class="input_container">
          <input
            type="text"
            name="cap"
            v-model="capInput"
            @input="onCapInput"
            :placeholder="'CAP'"
            inputmode="numeric"
            maxlength="5"
            class="no-spinners"
            autocomplete="off"
          />
        </div>
      </div>
    </div>
  </template>


<script>
export default {
  name: 'FormFieldAverage',
  props: {
    kmMensili: {
      type: Number,
      default: null,
    },
    cap: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      tooltipVisible: null,
      kmMensiliInput: '',      // Formatted input value for kmMensili
      kmMensiliNumeric: null,  // Actual numeric value to send to backend
      capInput: '',            // Input value for CAP
    };
  },
  methods: {
    toggleTooltip(key) {
      this.tooltipVisible = this.tooltipVisible === key ? null : key;
    },
    numberWithThousandSeparator(value) {
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    },
    onKmMensiliInput() {
      // Remove non-digit characters
      let numericValue = this.kmMensiliInput.replace(/\D/g, '');
      if (numericValue === '') {
        this.kmMensiliInput = '';
        this.kmMensiliNumeric = null;
      } else {
        // Format input with thousand separators
        this.kmMensiliInput = this.numberWithThousandSeparator(numericValue);
        // Store the numeric value
        this.kmMensiliNumeric = parseInt(numericValue, 10);
      }
    },
    onCapInput() {
      // Remove non-digit characters and limit to 5 digits
      let numericValue = this.capInput.replace(/\D/g, '').slice(0, 5);
      this.capInput = numericValue;
    },
  },
  mounted() {
    // Initialize kmMensiliInput and kmMensiliNumeric with prop value if provided
    if (this.kmMensili) {
      let numericValue = this.kmMensili.toString().replace(/\D/g, '');
      this.kmMensiliNumeric = parseInt(numericValue, 10);
      this.kmMensiliInput = this.numberWithThousandSeparator(numericValue);
    }
    // Initialize capInput with prop value if provided
    if (this.cap) {
      this.capInput = this.cap.toString().replace(/\D/g, '').slice(0, 5);
    }
  },
};
</script>


<style scoped>
.iconTooltip__container {
  position: relative;
}
.iconTooltip__container .tooltip {
  visibility: hidden;
  width: 400px;
  padding: 20px 5px;
  background-color: #fff;
  color: #333;
  text-align: center;
  position: absolute;
  z-index: 1;
  bottom: 130%;
  left: -130px;
  margin-left: -60px;
  box-shadow: 0px 0px 6px #00000045;
  display: flex !important;
  justify-content: center;
  align-items: center;
  font-weight: 300;
}
.iconTooltip__container .tooltip::after {
  content: '';
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #fff transparent transparent transparent;
}
.iconTooltip__container .tooltip-visible {
  visibility: visible;
}
  @media (max-width: 768px) {
  .iconTooltip__container .tooltip::after {
    margin-left: 140px;
  }
  .iconTooltip__container .tooltip {
    width: 350px;
    left: -250px;
  }
  #form_car .input_container input[type='text'] {
        width: 70%;
    }
}
</style>



// WEBPACK FOOTER //
// resources/js/app/components/FormFieldAverage.vue